import { Injectable } from "@angular/core";

@Injectable()
export class CargoValidators {

  public validateAddressEqualCity($event) {
    return null;
  }

}